/* istanbul ignore file */

export const DECIMAL_TOOLTIP_MESSAGE_CONSTANTS = {
    USDollarToolTip: 'US Dollar formatting requires two decimal places, so this setting is locked.',
    DurationToolTip: 'Duration formatting cannot have decimal places, so this setting is locked.',
    HoursToolTip: 'Hours formatting cannot have decimal places, so this setting is locked.',
};
